import { TextComponent } from '@manifest-cyber/design-system/lib/components/TextComponent';
import { Flex, Tooltip, UnstyledButton } from '@mantine/core';

export interface ManifestBreadcrumb {
  label: string;
  tooltipText: string;
  onClick?: () => void;
  isDisabled?: boolean;
}

interface ManifestBreadcrumbsProps {
  breadcrumbs: ManifestBreadcrumb[];
}

export const ManifestBreadcrumbs = ({ breadcrumbs }: ManifestBreadcrumbsProps) => {
  return (
    <Flex>
      {breadcrumbs.map((breadcrumb, index) => (
        <>
          <Tooltip label={breadcrumb.tooltipText} multiline>
            <UnstyledButton onClick={breadcrumb.onClick} disabled={breadcrumb.isDisabled}>
              <TextComponent
                variant="headerAllCaps"
                color="muted"
                hoverColor={!breadcrumb.isDisabled ? 'primary' : undefined}
              >
                {breadcrumb.label}
              </TextComponent>
            </UnstyledButton>
          </Tooltip>
          {index < breadcrumbs.length - 1 && (
            <TextComponent component="span" mx="8px" color="muted">
              /
            </TextComponent>
          )}
        </>
      ))}
    </Flex>
  );
};
